export default "__VITE_ASSET__BDsF1soh__"